import React from 'react'
import { RouteProps } from 'react-router-dom'
import { PostDetailPage } from 'components/billboard'
import { IncidentReportDetail } from 'components/incident-reports'
import {
  Admin,
  AmenityBooking,
  Billboard,
  Calendar,
  Dashboard,
  Documents,
  IncidentReports,
  LandingPage,
  Messages
} from 'pages'

const NivosRoutes: RouteProps[] = [
  {
    path: '/dashboard',
    element: <Dashboard />
  },
  {
    path: '/documents',
    element: <Documents />
  },
  {
    path: '/messages',
    element: <Messages />
  },
  {
    path: '/incident-reports',
    element: <IncidentReports />
  },
  {
    path: '/incident-reports/:id',
    element: <IncidentReportDetail />
  },
  {
    path: '/amenity-booking',
    element: <AmenityBooking />
  },
  {
    path: '/billboard',
    element: <Billboard />
  },
  {
    path: '/billboard/posts/:id',
    element: <PostDetailPage />
  },
  {
    path: '/admin',
    element: <Admin />
  },
  {
    path: '/calendar',
    element: <Calendar />
  }
]

const PublicRoutes: RouteProps[] = [
  {
    path: '/',
    element: <LandingPage />
  }
]

export { NivosRoutes, PublicRoutes }

export default NivosRoutes
